<template>
  <div class="report-wrap">
    <div class=" content">
      <div class="title-wrap dn-content-bg">
            <time-search
                    ref="timeSearch"
                    :control="{data:timeData}"
                    @timeControlChange="timeControlChange"
                    @timeControlClick="TimeControlClick"
                    :showExportBtn="true"
                    :showPrint="true"
                    :showPrintId="'table'"
                    :showPrintTitle="'告警报表'"
                    @exportExc="bindExportExc"
                >
            </time-search>
        <div>
        </div>
      </div>
      <div class="table-content  box"  style="flex: 1;display: flex;" >
        <nk-table
           id="table"
          :data="tableData"
          :emptyText="'该时间段暂无告警'"
          :columns="columns"
          :showPage="true"
          :page="page"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
        </nk-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from "@/utils/index.js";
import NkTable from "@/components/common/NkTable";
import TimeSearch from "@/components/common/TimeSearch.vue";
import tree from '@/utils/tree'
import * as fpg from '@/utils/fpg.js'
import DateTool from '@/utils/dateTool' 
let allTimeData = [
        {
            type: "day",
            label: "日",
        },
        {
            type: "month",
            label: "月",
        },
        {
            type: "year",
            label: "年",
        },
    ];
export default {
    components: { NkTable,TimeSearch },
    data() {
        return {
            timeData: allTimeData,
            selectedDate: {},
            tableData:[],
            columns:[],
            page: {
                pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
                size: 10,
                total: 0,
                pageIndex: 1,
            },
            viewId:'',
        }
    },
    created() {
        let vm=this
        let time = new Date();
        let startTime = DateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
        time.setDate(time.getDate() + 1);
        let endTime = DateTool.format(time, "yyyy-MM-dd") + " 00:00:00";

        vm.selectedDate = {
            dataType: "1",
            dateType: "day",
            endTime: endTime,
            startTime: startTime,
        };
        vm.TimeControlClick(vm.selectedDate);
    },
    mounted() {},
    watch: {},
    methods: {
        timeControlChange() {},
        //查询事件
        TimeControlClick(e) {
            let vm = this;
            vm.selectedDate = e;
            vm.getData(1)
        },
        //获取左边数据
        async getData(pageIndex) {
            let vm = this
            let res1=await vm.$api.tmp.getEventRecordGroupStatistics(vm.selectedDate.startTime,vm.selectedDate.endTime)
            let tableData = [];
            let columns =[
                    {
                        label: "序号",
                        fixed: "left",
                        show: true,
                        width:"100",
                        type:'index',
                        align: "center",
                    },
                    {
                        label: "告警数",
                        show: true,
                        prop: "count",
                    },
                    {
                        label: "确认数",
                        show: true,
                        prop: "confirmingCount",
                    },
                    {
                        label: "处理数",
                        show: true,
                        prop: "handlingCount",
                    },
                    {
                        label: "告警等级一",
                        show: true,
                        prop: "level1",
                    },
                    {
                        label: "告警等级二",
                        show: true,
                        prop: "level2",
                    },
                    {
                        label: "告警等级三",
                        show: true,
                        prop: "level3",
                    },
                    {
                        label: "告警等级四",
                        show: true,
                        prop: "level4",
                    },
                    {
                        label: "告警等级五",
                        show: true,
                        prop: "level5",
                    },
                    {
                        label: "告警等级六",
                        show: true,
                        prop: "level6",
                    },
                    {
                        label: "遥测量告警",
                        show: true,
                        prop: "RemoteMeasurementAlarm",
                    },
                    {
                        label: "遥信量告警",
                        show: true,
                        prop: "RemoteSignlAlarm",
                    },
                    {
                        label: "通信告警",
                        show: true,
                        prop: "CommunicationAlarm",
                    },
                    {
                        label: "限额告警",
                        show: true,
                        prop: "LimitAlarm",
                    },
                    {
                        label: "系统告警",
                        show: true,
                        prop: "SystemAlarm",
                    }
                ];
            vm.columns=columns
            if(res1.success){
                res1.data.forEach(item=>{
                    tableData.push(item)
                })
                let datas = toPage(tableData, pageIndex, vm.page.size);
                vm.page.pageIndex = pageIndex;
                vm.page.total = datas.total;
                vm.tableData=datas.arr;
            }else{
                vm.$message.error(res.msg)
                vm.page.pageIndex = pageIndex;
                vm.page.total =0;
                vm.tableData=[]
            }
        },
        bindExportExc() {
            //表格导出
            let name = "告警报表";
            exportExcel("table", name, this.selectedDate);
        },
        handleCurrentChange(val) {
            this.getData(val);
        },
        handleSizeChange(val) {
            this.page.size = val;
            this.getData(1);
        }
    },
};
</script>
<style lang="scss" scoped>
@page {
    size: auto;  /* auto is the initial value */
    margin: 0mm; /* this affects the margin in the printer settings */
}
.btn{
    background: #5fa4e8;
    color: #fff;
}
.black{
    color: #fff;
}
.report-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .content {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .title-wrap {
    width: 100%;
    height: 50px;
    line-height: 40px;
    border-bottom: 1px solid rgb(214, 214, 214);
    margin-bottom: 14px;
    color: #000;
    display: flex;
    align-items: center;
    .title-content {
      font-weight: bold;
    }
  }
  .list1{
        display: flex;
        flex:1;
        flex-wrap: wrap;
        color:#000;
        .item{
            display: flex;
            align-items: center;
            border: 1px solid #5f5f5f;
            padding: 0px 6px;
            margin: 5px;
            .item-title{
                margin-right: 10px;
            }
        }
    }
}
.rows{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.addRow{
    margin-left: 67px;
    border: 1px dashed #797979;
    text-align: center;
    padding: 5px;
    margin-right: 87px;
    cursor: pointer;
}
.addRow1{
    margin-left: 38px;
    border: 1px dashed #797979;
    text-align: center;
    padding: 5px;
    margin-right: 18px;
    cursor: pointer;
}
.maxHeight{
    max-height: 350px;
    overflow: auto;
}
.treeBox{
    max-height: 450px;
    overflow: auto;
}
.layou-container {
    overflow: none;
    text-overflow: none;
    white-space: ''
}
.verticalSave{
    margin-left:262px;margin-top:10px
}
.mesureName{
    max-width:200px;white-space: break-spaces;margin-right:7px
}
.time-warp{
    width: 100%;
    height: 100%;
    padding: 0px 10px;
    box-sizing: border-box;
    align-items: center;
    display: flex;
}
</style>